import React from 'react';
import { Card, CardContent } from '@tmap/mmm-style-guide/src/Card';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Skeleton } from '@tmap/mmm-style-guide/src/Skeleton';

import { styled } from '@tmap/mmm-style-guide/src/styled';
import BlockContent from '../block-content';
import { MiniProfile } from './miniProfile';

const StyledCard = styled(Card)(() => ({
  padding: '28px 12px',
  height: '100%',
  borderRadius: '8px',
}));

const Header = styled('div')(({ theme }) => ({
  fontSize: 10,
  fontWeight: 500,
  color: theme.palette.primary.veryDark,
  marginBottom: theme.spacing(2),
}));

const StyledContent = styled(CardContent)(({ theme }) => ({
  padding: '0 16px !important',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '400px',
  height: '100%',
  '.MuiTypography-body1': {
    fontWeight: 500,
  },
  '.authorName': {
    color: theme.palette.secondary.main,
    fontSize: '14px',
    fontWeight: 600,
  },
  '.authorTitle': {
    fontSize: '14px',
    fontStyle: 'italic',
  },
}));

function TextTestimonial({
  locationText,
  testimonial,
  shouldLazyLoad = true,
  lazyProps = { offset: 300 },
}) {
  const {
    body,
    profile = null,
  } = testimonial || {};
  const skeleton = !testimonial;

  return (
    <StyledCard elevation={1}>
      <StyledContent>
        <Grid item>
          <Header>WHAT {locationText.toUpperCase()} RESIDENTS ARE SAYING</Header>
          {skeleton ? (
            <>
              <Skeleton sx={{ fontSize: '20px' }} />
              <Skeleton sx={{ fontSize: '20px' }} />
              <Skeleton sx={{ fontSize: '20px' }} />
              <Skeleton sx={{ fontSize: '20px' }} width='75%' />
            </>
          ) : (
            <BlockContent value={body} nested />
          )}
        </Grid>
        {(profile || skeleton) && (
          <Grid item>
            <MiniProfile data={profile} shouldLazyLoad={shouldLazyLoad} {...lazyProps} />
          </Grid>
        )}
      </StyledContent>
    </StyledCard>
  );
}

export default TextTestimonial;
